import { Text } from '@chakra-ui/layout';
import { Box, Flex, Icon } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { formatDistanceStrict } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PinIcon from '@/assets/icons/ic-pin.svg';

import { GeneralMarkdown } from '@/components/ui/shared/markdowns/GeneralMarkdown/GeneralMarkdown';
import { FontFamily } from '@/enums/index';
import { EventAnnouncement } from '@/resources/EventAnnouncement';
import { IThemeProps } from '@/styles/themes/types';

const Title = styled.p<IThemeProps>`
  font-family: ${({ theme }) => theme.legacy.typography.fontFamily[FontFamily.SpaceGrotesk]};
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
  margin-top: 0;

  color: ${({ theme }) => theme.legacy.colors.black};
`;

interface IAnnouncementCardProps {
  announcement: EventAnnouncement;
}

export const AnnouncementCard: FC<IAnnouncementCardProps> = ({
  announcement: { createdAt, title, description, pinned },
  ...restProps
}) => {
  const { t } = useTranslation();

  return (
    <Box mb={8} {...restProps}>
      <Flex justifyContent="space-between">
        <Text fontSize="sm" color="gray.800">
          {t('announcement.createdAt', {
            time: formatDistanceStrict(new Date(createdAt), Date.now()),
          })}
        </Text>
        {pinned && <Icon w="24px" h="24px" as={PinIcon} />}
      </Flex>
      <Title>{title}</Title>
      <GeneralMarkdown fontSize="sm" source={description} />
    </Box>
  );
};
